import { CalendarEvent, ProcessedEvent } from '../types'
import { areIntervalsOverlapping } from 'date-fns'
import {
  minutesFromStartHour,
  snapCalc,
} from './positionCalculations'
import { intervalFromDuration } from '@pogokid/util/datetime'

export function overlappingEventsWith(
  todayEvents: CalendarEvent[],
  event: CalendarEvent
): CalendarEvent[] {
  const eventInterval = intervalFromDuration(
    event.start,
    event.duration
  )
  return todayEvents.filter((e) => {
    const comparisonEventInterval = intervalFromDuration(
      e.start,
      e.duration
    )
    return (
      e.uid !== event.uid &&
      areIntervalsOverlapping(
        eventInterval,
        comparisonEventInterval,
        { inclusive: false }
      )
    )
  })
}

interface BucketOverlappingEventsOptions {
  events: ProcessedEvent[]
  step: number
}

interface BucketOverlappingEventsResult {
  events: ProcessedEvent[]
}

export function bucketEventsWithinSteps({
  events,
  step,
}: BucketOverlappingEventsOptions) {
  const buckets = new Map<
    number,
    BucketOverlappingEventsResult
  >()
  events.forEach((event) => {
    const startMinutes = minutesFromStartHour(0, event.start)
    const { snaps } = snapCalc(
      step,
      startMinutes,
      event.duration
    )
    snaps.forEach((snap) => {
      const result = buckets.get(snap) || {
        events: [],
      }
      result.events.push(event)
      buckets.set(snap, result)
    })
  })
  return new Map(
    [...buckets].sort((a, b) => (a[0] > b[0] ? 1 : -1))
  )
}
